import actionTypes from '../constants/action-types';

const publishWebsite = (vhostName = null, isThirdPartyDomain = false) => ({
  type: actionTypes.PUBLISH_WEBSITE,
  payload: {
    vhostName,
    isThirdPartyDomain,
  },
});

export default publishWebsite;
